import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NotificationFacade } from '@core/facades/notification.facade';
import { AccountManagementService } from '@core/services/account-management.service';
import { CorporateRegistrationService, GetAccountSignatoriesData } from '@core/services/corporate-registration.service';
import { BaseSelectDirective } from '@shared/directives/base-select.directive';
import { ButtonDirective, SpinDirective } from '@shared/directives/button.directive';
import { InputLabelComponent } from '@shared/ui/input-label/input-label.component';
import { SlideInRightModalComponent } from '@shared/ui/slide-in-right-modal/slide-in-right-modal.component';

@Component({
  selector: 'app-attach-account',
  standalone: true,
  imports: [
    CommonModule,
    SlideInRightModalComponent,
    InputLabelComponent,
    FormsModule,
    ReactiveFormsModule,
    BaseSelectDirective,
    ButtonDirective,
    SpinDirective
  ],
  templateUrl: './attach-account.component.html',
  styleUrl: './attach-account.component.scss'
})
export class AttachAccountComponent implements OnInit{
  fb = inject(FormBuilder);
  activatedRoute = inject(ActivatedRoute);
  accountService = inject(AccountManagementService);
  notify = inject(NotificationFacade)


  corporateService = inject(CorporateRegistrationService);

  returnPathUrl!: string;
  isLoading = false;
  signatories: GetAccountSignatoriesData[] = [];
  isCorporate = false;


  accountTypeForm = this.fb.nonNullable.group({
    profileId: ['', Validators.required],
    accountType: ['', Validators.required]
  });

  ngOnInit() {
    const profileId = this.activatedRoute.snapshot.params['profileId'];
    if (profileId) {
      this.accountTypeForm.patchValue({ profileId });
      return;
    }
    // corporate route: no owner profile, so the admin picks a signatory
    this.isCorporate = true;
    const accountId = this.activatedRoute.parent?.snapshot.params['accountId'];
    this.corporateService.getAccountSignatories(accountId).subscribe({
      next: (response) => (this.signatories = response.data),
      error: () => this.notify.error('Failed to fetch signatories'),
    });
  }

  attachAccount() {
    this.isLoading = true;
    const { profileId, accountType } = this.accountTypeForm.getRawValue();
    this.accountService.attachAccountToProfile(profileId, accountType)
      .subscribe({
        next: (response) => {
          this.isLoading = false;
          this.notify.success('Account successfully attached');
          
        },
        error: (error) => {
          this.isLoading = false;
          this.notify.error(error?.error?.message ?? 'Failed to attach account. Please try again.');

        }
      });
  }
}